import React from 'react';

import { Icon, Button } from '..';


export const CancelButton = ({ title, onClick, vendorClass }) => (
  <Button
    additions={ [ 'fit-content', 'danger-icon' ] }
    vendorClass={ vendorClass }
    onClick={ onClick }
  >
    <Icon
      svg="CROSS"
      svgProps={{ width: '28', height: '28' }}
    />
    <p>{ title }</p>
  </Button>
);
